export const setupPerformancePolyfill = window => {
  const startOffset = Date.now ? Date.now() : +new Date();
  const performance = window.performance || {};

  if (!performance.now) {
    const polyfill = () => (Date.now ? Date.now() : +new Date()) - startOffset;

    performance.now = performance.webkitNow || performance.mozNow || performance.msNow || polyfill;
  }

  if (!performance.mark) {
    performance.mark = () => {};
  }

  if (!performance.measure) {
    performance.measure = () => {};
  }

  window.performance = performance;
};
